<!-- <p>auto-replace-dialog works!</p> -->
<div class="manualReplace">
  <div
    class="manualReplace-header flex justify-between font-bold text-black text-lg p-4"
  >
    <div>Manual Replace</div>
    <mat-icon mat-dialog-close class="pointerCursor">close</mat-icon>
  </div>
  <div
    *ngIf="!isDataLoading"
    class="manualReplace-content px-8"
    [ngClass]="{
      'manualReplace-content-noQuestions':
        generatedAutoReplaceQuestions.length <= 0
    }"
  >
    <div
      *ngIf="generatedAutoReplaceQuestions.length <= 0"
      class="text-slate-500 font-bold text-xl pb-4"
    >
      No Questions are available to replace
    </div>
    <div *ngIf="generatedAutoReplaceQuestions.length > 0">
      <div
        *ngFor="
          let generatedQuestionsObj of generatedAutoReplaceQuestions;
          let generatedQuestionsObjIndex = index
        "
        class="flex flex-col gap-4 pb-4"
      >
        <div class="flex gap-4">
          <div>{{ generatedQuestionsObjIndex + 1 }})</div>
          <div class="flex flex-col gap-4">
            <div
              *ngFor="
                let generatedQuestionObj of generatedQuestionsObj.question
                  .questionData;
                let generatedQuestionObjIndex = index
              "
            >
              <!-- ** Questions -->

              <app-multi-data
                [multiData]="{
                  type: generatedQuestionObj.type,
                  data: generatedQuestionObj.data,
                  tikzId:
                    'autoReplaceQuestion-' +
                    generatedQuestionsObjIndex +
                    '-' +
                    generatedQuestionObjIndex,
                  imageKeys: generatedQuestionObj.images!,
                  listOfImages: images
                }"
              ></app-multi-data>
            </div>
          </div>
        </div>
        <!-- ** For choices -->
        <div class="px-8">
          <div *ngIf="generatedQuestionsObj.question.questionType === 1">
            <div
              *ngFor="
                let generatedChoicesObj of generatedQuestionsObj.choices;
                let generatedChoicesObjIndex = index
              "
              class="flex gap-4"
            >
              <div>{{ getChoiceOption(generatedChoicesObjIndex) }}</div>
              <div class="flex flex-col gap-4">
                <div
                  *ngFor="
                    let generatedChoiceObj of generatedChoicesObj.optionValue;
                    let generatedChoiceObjIndex = index
                  "
                >
                  <div class="flex gap-4">
                    <app-multi-data
                      [multiData]="{
                        type: generatedChoiceObj.type,
                        data: generatedChoiceObj.data,
                        tikzId:
                          'autoReplaceChoiceOption-' +
                          generatedQuestionsObjIndex +
                          '-' +
                          generatedChoicesObjIndex +
                          '-' +
                          generatedChoiceObjIndex,
                        imageKeys: generatedChoiceObj.images!,
                        listOfImages: images
                      }"
                    ></app-multi-data>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="generatedQuestionsObj.question.questionType === 2">
            <div>
              {{ getPossibilities(generatedQuestionsObjIndex) }}
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <span
            class="p-2.5 bg-blue-800 text-white font-bold rounded-lg"
            [mat-dialog-close]="
              selectQuestionToReplace(generatedQuestionsObjIndex)
            "
            >Replace</span
          >
        </div>
        <mat-divider></mat-divider>
      </div>
    </div>
  </div>
  <div *ngIf="isDataLoading" class="flex justify-center">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
  </div>
</div>
